"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const usa_tooltip_1 = __importDefault(require("@uswds/uswds/js/usa-tooltip"));
const uswds_react_utils_1 = require("@boozallen-uip/uswds-react-utils");
const Tooltip = (0, react_1.forwardRef)(({ children, className, content, position = 'right', ...props }, ref) => {
    const containerRef = (0, react_1.useRef)(null);
    (0, react_1.useImperativeHandle)(ref, () => containerRef.current);
    (0, react_1.useEffect)(() => {
        const containerEl = containerRef.current;
        if (!containerEl)
            return;
        // call USWDS's `on` function to initialize the component
        usa_tooltip_1.default.on(containerEl);
        // on dismount, call USWDS's `off` function to cleanup the component
        return () => {
            usa_tooltip_1.default.off(containerEl);
        };
    }, []);
    return ((0, jsx_runtime_1.jsx)("div", { ref: containerRef, className: (0, uswds_react_utils_1.createClassString)('bah-uswds-tooltip', className), ...props, children: (0, uswds_react_utils_1.flattenChildren)(react_1.Children.toArray(children)).map((child) => {
            if ((0, react_1.isValidElement)(child)) {
                return (0, react_1.cloneElement)(child, {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    className: 'usa-tooltip',
                    'data-position': position,
                    title: content
                });
            }
            return child;
        }) }));
});
exports.default = Tooltip;
